import Vue from "vue";
import Router from "vue-router";

import { monitorZoom } from "../utils/monitorZoom.js";
const m = monitorZoom();

Vue.use(Router);

let originPush = Router.prototype.push; //备份原push方法

Router.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    //如果传了回调函数，直接使用
    originPush.call(this, location, resolve, reject);
  } else {
    //如果没有传回调函数，手动添加
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};
const routers = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "AnswerIndex",
      component: () => import("@/components/MainPage/AnswerIndex"),
    },
    {
      path: "/articleDetails",
      name: "articleDetails",
      component: () => import("@/components/MainPage/articleDetails"),
    },
    {
      path: "/newsUpdates",
      name: "newsUpdates",
      component: () => import("@/components/MainPage/newsUpdates"),
    },
    {
      path: "/newsDetails",
      name: "newsDetails",
      component: () => import("@/components/MainPage/newsDetails"),
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      component: () => import("@/components/MainPage/aboutUs"),
    },
    {
      path: "/joinUs",
      name: "joinUs",
      component: () => import("@/components/MainPage/joinUs"),
    },
    {
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: () => import("@/components/MainPage/privacyPolicy"),
    },
  ],
});

routers.beforeEach((to, from, next) => {
  console.log("即将跳转到的路由 ------------------------ >  " + to.name, from);
  let mqList = window.matchMedia("(min-width: 768px)");
  // console.log(mqList.matches)
  if (mqList.matches) {
    /* 调整缩放比例 start */
    //针对工控屏调整的缩放比
    if (window.screen.width <= 1024) {
      document.body.style.zoom = 60 / Number(m); //60是对着屏幕具体调的，因屏而异
    } else if (window.screen.width <= 1440) {
      document.body.style.zoom = 74.5 / Number(m);
    } else {
      document.body.style.zoom = 100 / Number(m);
    }
    /* 调整缩放比例 end */
  }

  next();
});

// Router.beforeEach((to, from, next) => {
//   console.log("即将跳转到的路由 ------------------------ >  " + to.name,from, next);
//   /* 调整缩放比例 start */
//   //针对工控屏调整的缩放比
//   if (window.screen.width <= 1024) {
//     document.body.style.zoom = 60 / Number(m);//60是对着屏幕具体调的，因屏而异
//   }else {
//     document.body.style.zoom = 100 / Number(m);
//   }
//   /* 调整缩放比例 end */
// })

export default routers;
